import { faPencil } from '@fortawesome/pro-regular-svg-icons';
import Button from 'components/UI/V3/Button/Button';
import { FunctionComponent } from 'react';
import styles from './SaleDetailFooter.module.scss';

interface SaleDetailFooterProps {
    isIncomplete: boolean;
    canEdit: boolean;
    onCollectPayment: () => void;
    onEdit: () => void;
}

export const SaleDetailFooter: FunctionComponent<SaleDetailFooterProps> = ({
    isIncomplete,
    canEdit,
    onCollectPayment,
    onEdit
}) => {
    if (isIncomplete) {
        return (
            <footer className={styles.footer}>
                <Button
                    label="Edit"
                    leftIcon={faPencil}
                    variant="primary"
                    onlyIcon
                    className={styles.editButton}
                    onClick={onEdit}
                />
            </footer>
        );
    }

    return (
        <footer className={styles.footer}>
            {canEdit && (
                <Button
                    label="Edit"
                    leftIcon={faPencil}
                    variant="primary"
                    onlyIcon
                    className={styles.editButton}
                    onClick={onEdit}
                />
            )}
            <Button
                label="Collect Payment"
                variant="black"
                fullWidth
                className={styles.payButton}
                onClick={onCollectPayment}
            />
        </footer>
    );
};

export default SaleDetailFooter;
